import { selectAll } from "@utils/function";

// ------------------------------------------------------------
// set active row

export default function SetActiveRow(id) {
  const rows = selectAll(`[data-id="${id}"]`);
  rows.forEach((row) => {
    row.classList.add("active-row");
  });
}
